import { makeStyles, Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		locatorwrapper: {
			overflowX: 'hidden',
		},
		drawer: {
			width: '56%',
			maxWidth: 960,
			flexShrink: 0,
			height: '100%',
		},
		drawerPaper: {
			width: '100%',
			position: 'initial',
			borderRight: 'unset',
		},
		content: {
			flexGrow: 1,
			transition: theme.transitions.create('margin', {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			}),
			marginLeft: '-50px',
		},
		contentShift: {
			transition: theme.transitions.create('margin', {
				easing: theme.transitions.easing.easeOut,
				duration: theme.transitions.duration.enteringScreen,
			}),
			marginLeft: 0,
		},
	}),
);
